import * as React from 'react';
import { Pane, PaneBackButton, PaneBody, PaneHeader } from '../../atoms/applications/page';
import { inject, observer } from 'mobx-react';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { CardSummary } from '../../molecules/payment/CardInput';
import './confirmationPane.module.scss';
import {
  SummaryBody,
  SummaryHeader,
  SummaryPriceRow,
  SummarySplitter,
  SummarySubPriceRow,
  SummaryTextRow,
} from '../../molecules/applications/base';
import { ApplicationErrorSummary } from '../../molecules/applications/ApplicationErrorSummary';
import { observable, makeObservable } from 'mobx';
import { MembershipPlanUpdateState } from '../../../containers/membership_plans/states/MembershipPlanUpdateState';
import { DetailedDate } from '@sheinc/design-system';
import moment from 'moment-timezone';

type Props = {
  pageState: MembershipPlanUpdateState;
};

export const ConfirmationPane = inject('pageState')(
  observer(
    class ConfirmationPane extends React.Component<Props> {
      agreed = false;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          agreed: observable,
        });
      }

      render() {
        const {
          pageState: { error, cardState, selectedPlan, selectedItem, submitState, submit, currentSubscriptionSummary },
        } = this.props;
        if (!selectedItem || !selectedPlan || !cardState.card) {
          return null;
        }
        const updateDate = moment(currentSubscriptionSummary.next_updatable_date);
        return (
          <Pane id="confirmation-pane">
            <PaneBackButton />
            <PaneHeader>変更内容の確認</PaneHeader>
            <PaneBody>
              <SummaryHeader styleName="first-header">変更プランの開始日</SummaryHeader>
              <SummaryBody>
                <SummaryTextRow className="new-plan-name" label="変更後" text={selectedItem.name} textSize="l" />
                <SummarySplitter />
                <SummaryTextRow
                  className="current-plan-name"
                  label="変更前"
                  text={currentSubscriptionSummary.plan_name}
                />
              </SummaryBody>
              <SummaryHeader>変更後のプラン開始日</SummaryHeader>
              <SummaryBody>
                <SummaryTextRow
                  className="new-plan-start-date"
                  label="開始日"
                  text={
                    updateDate ? <DetailedDate date={updateDate} /> : <DetailedDate date={moment().add(10, 'day')} />
                  }
                  textSize="l"
                />
              </SummaryBody>
              <SummaryHeader>お支払い金額</SummaryHeader>
              <SummaryBody>
                <SummarySubPriceRow label="プラン料金" price={selectedItem.price} unit="円" />
                <SummarySubPriceRow label="消費税" price={selectedItem.tax} unit={'円'} />
                <SummarySplitter />
                <SummaryPriceRow label="合計" price={selectedItem.total_price} unit={'円'} />
              </SummaryBody>
              <SummaryHeader>お支払い方法</SummaryHeader>
              <SummaryBody>
                <CardSummary styleName="card-summary" card={cardState.card} />
              </SummaryBody>
              {error && (
                <ApplicationErrorSummary title="お申し込みを確定することができませんでした。" type="normal">
                  考えられる要因
                  <br />
                  ・クレジットカードの限度額
                  <br />
                  ・引き落とし先の銀行口座の残高不足
                  <br />
                  など
                </ApplicationErrorSummary>
              )}
              <ButtonWrapper>
                <SubmitButton id="submit-button" loading={submitState.submitting} onClick={submit}>
                  お申し込みの確定へ
                </SubmitButton>
              </ButtonWrapper>
            </PaneBody>
          </Pane>
        );
      }
    }
  )
);
